/**************
 Global
 ***************/

// When subscriptions are added to cart, check if we should auto add a product
async function checkAutoAdd(formData) {

    // if the form data isn't an array of items, make it one
    if (!Array.isArray(formData.items)) {
        let newFormData = {
            items: []
        }
        newFormData.items.push(formData);
        formData = newFormData;
    }

    // gummies add a different product
    let gummiesVariantIds = [47211652415733, 47211652448501, 47211652481269, 9563331297525];
    let isGummies = formData.items.some(item => gummiesVariantIds.includes(item.id));

    // check if gummies auto add is enabled
    if (isGummies && !gummiesAutoAddEnabled) {
        return formData;
    }

    if (isGummies && !gummiesAutoAddOverride) {
        // check if gummies has selling plan
        let gummiesHasSellingPlan = formData.items.some(item => gummiesVariantIds.includes(item.id) && item.selling_plan);
        if (gummiesHasSellingPlan) {
            // add pillow if not in cart
            let tempCart = await window.upcartGetCart();
            const cartHasPillow = tempCart.items.some(item => item.productId === 9447831372021);
            if (!cartHasPillow) {
                formData.items.push({
                    id: 47406608122101,
                    quantity: 1
                });
            }
            return formData;
        }
    }


    if (!autoAddProduct) {
        return formData;
    }

    if (!autoAddProduct.variants[0].available) {
        return formData;
    }

    // check if the cart already has the auto add product
    let tempCart = await window.upcartGetCart();
    const cartHasAutoAddProduct = tempCart.items.some(item => item.productId === autoAddProduct.id);

    // check if this add is already bringing the auto add product with it, so bundles that
    // include it don't get a second copy pushed in before the first one reaches the cart
    const autoAddVariantIDs = autoAddProduct.variants.map(variant => variant.id);
    const formHasAutoAddProduct = formData.items.some(item => autoAddVariantIDs.includes(item.id));

    if (cartHasAutoAddProduct || formHasAutoAddProduct) {
        return formData;
    }

    let hasSellingPlan = false;

    // if the formData is an array, we need to check each item for selling_plan
    if (Array.isArray(formData.items)) {
        // check if any item has a selling plan
        hasSellingPlan = formData.items.some(item => item.selling_plan);
    } else {
        // if it's not an array, just check the formData itself
        hasSellingPlan = !!formData.selling_plan;
    }

    // if there's a selling plan, add the auto add product
    if (hasSellingPlan) {
        // add bottle
        formData.items.push({
            id: autoAddProduct.variants[0].id,
            quantity: 1
        });
    }

    return formData;
}


//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
async function addProduct(formData, skipFreeGift = false) {

    // check if we should auto add a product, unless the caller opted out of the free gift
    if (!skipFreeGift) {
        formData = await checkAutoAdd(formData);
    }

    return fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 } or items: [{ quantity: 1, id: 794864229 }]
function changeCart(formData) {
    return fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
//let formData = {updates: { 794864229: 2, 794864230: 3 }}
function updateCart(formData) {
    return fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

// download product
function downloadProduct(handle) {
    return fetch(`${Shopify.routes.root}products/${handle}.js`)
        .then(data => data.json());
}

// get cart
function getCart() {
    return fetch(`${Shopify.routes.root}cart.js`)
        .then(data => data.json());
}

// print price (515491 => $5,154.91)
function price(amountInCents, removeTrailingZeros = false) {
    // calculate total
    let total = (parseFloat(amountInCents) / 100).toFixed(2).toString();

    // add commas if needed
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // remove trailing zeros
    if (removeTrailingZeros) {
        total = total.toString().replace(".00", "");
    }

    // return total
    return `${currency}${total}`;
}

// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/**************
 Design mode open mini cart
 ***************/
if (Shopify.designMode) {
    // if a user clicks on the mini cart
    document.addEventListener('shopify:section:select', function (event) {
        // open mini cart
        if (event.detail.sectionId === 'theme-mini-cart') {
            openCart();
        }

        // if they deselect the mini cart
        if (event.detail.sectionId !== 'theme-mini-cart') {
            closeCart();
        }
    });
}

// scroll to url hash
const maltertechParams = new URLSearchParams(window.location.search);

if (maltertechParams.get("scroll_to_class")) {
    const element = document.querySelector(`.${maltertechParams.get("scroll_to_class")}`);
    if (element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - 120,
        })
    }
}

if (maltertechParams.get("scroll_to_id")) {
    const element = document.querySelector(`#${maltertechParams.get("scroll_to_id")}`);
    if (element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - 120,
        })
    }
}

// Function to send back in stock subscription to Klaviyo
async function sendKlaviyoBackInStockRequest(emailAddress, variantID) {
    await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${await klaviyo.account()}`, {
        method: 'POST',
        headers: {
            accept: 'application/vnd.api+json',
            revision: '2024-10-15',
            'content-type': 'application/vnd.api+json'
        },
        body: JSON.stringify({
            data: {
                type: "back-in-stock-subscription",
                attributes: {
                    channels: ["EMAIL"],
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: emailAddress,
                            }
                        }
                    }
                },
                relationships: {
                    variant: {
                        data: {
                            type: "catalog-variant",
                            id: `$shopify:::$default:::${variantID}`,
                        }
                    }
                }
            }
        })
    })
}


/**************
 Collection Item Form
 ***************/
document.querySelectorAll('.collectionItem')?.forEach(function (item) {

    let product = JSON.parse(item.dataset.product);
    let activeItemVariant = JSON.parse(item.dataset.variant);
    const subscriptionAppID = item.dataset.subscriptionAppId;

    // function to return the selling_plan_id given a variant ID
    function getSellingPlanID() {
        // create an array of selling plans that are accessible for the variant
        const validSellingPlans = [];

        // loop over each group
        for (const group of product.selling_plan_groups) {
            // if the group doesn't match our subscription app ID, skip it
            if (group.app_id !== subscriptionAppID) {
                continue
            }

            // loop through each selling plan in the group
            for (const plan of group.selling_plans) {
                // add the plan ID to the validSellingPlans array
                validSellingPlans.push(plan.id);
            }
        }

        // loop through selling plan allocations of the variant and find the first one that matches a valid selling plan
        for (const allocation of activeItemVariant.selling_plan_allocations) {
            if (validSellingPlans.includes(allocation.selling_plan_id)) {
                return allocation.selling_plan_id;
            }
        }

        // if no valid selling plan is found, return null
        return null;
    }

    // Quantity input (Pack size)
    let quantityInput = item.querySelector('.collectionItemSelect') || false;
    if (quantityInput) {

        // listen for input change and update item
        quantityInput.addEventListener('change', function () {

            // update variant data for the item

            // find the variant
            let options = [item.dataset.flavor, this.value];

            // special case - if this is homestyle, add homestyle option
            if (product.id === 9224088256757) {
                options.push('Homestyle');
            }

            let activeItemVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options);
            });

            // update data
            item.dataset.variant = JSON.stringify(activeItemVariant);
            updateItem()
        });
    }

    // Selling Plan input (Subscription)
    item.querySelectorAll('.collectionItemSubInput')?.forEach((input) => {
        input.addEventListener('change', function () {
            updateItem();
        });
    })


    // Update Item
    function updateItem() {

        // get active variant
        activeItemVariant = JSON.parse(item.dataset.variant);


        /**************
         ATC Enable/Disable
         ***************/
        // check if the variant is in stock
        if (activeItemVariant.available) {
            item.querySelector(".collectionItemATC").disabled = false;
            item.querySelector(".collectionItemATC").textContent = "Add To Cart";
        } else {
            item.querySelector(".collectionItemATC").disabled = true;
            item.querySelector(".collectionItemATC").textContent = "Sold Out";
        }

        // atc price
        if (item.classList.contains('showPrice') && activeItemVariant.available) {
            item.querySelector(".collectionItemATC").textContent = "Add To Cart - " + price(activeItemVariant.price, true);
        }


        // update quick add data
        item.querySelector('.quickAdd').dataset.id = activeItemVariant.id;

        /**************
         Price
         ***************/
        let sellingPlanExists = item.querySelector('.collectionItemWrap') || false;

        // if there's a subscription we need to update both prices
        if (sellingPlanExists) {
            // Select both sets of elements at once
            let compares = item.querySelectorAll(".collectionItemSubBodyHeaderPriceCompare");
            let reals = item.querySelectorAll(".collectionItemSubBodyHeaderPriceReal");

            // reset compares
            compares.forEach(compare => compare.textContent = "");

            // Destructure them for clarity:
            // Assuming the markup is structured so that index 0 is for subscription, index 1 for one-time purchase
            let [subCompare, oneTimeCompare] = compares;
            let [subReal, oneTimeReal] = reals;

            // find the allocation that matches the selling plan ID
            let allocation = activeItemVariant.selling_plan_allocations.find(allocation => allocation.selling_plan_id === getSellingPlanID());

            let allocationPrice = allocation.price;

            // Update subscription prices
            if (activeItemVariant.price > allocationPrice) {
                subCompare.textContent = price(activeItemVariant.price, true);
            }
            subReal.textContent = price(allocationPrice, true);

            // Update one-time purchase prices
            if (activeItemVariant.compare_at_price > activeItemVariant.price) {
                oneTimeCompare.textContent = price(activeItemVariant.compare_at_price, true);
            }
            oneTimeReal.textContent = price(activeItemVariant.price, true);

            // update quick add data
            if (item.querySelector('.collectionItemSubInput:checked').value === 'sub') {
                item.querySelector('.quickAdd').dataset.selling = getSellingPlanID();
            } else {
                item.querySelector('.quickAdd').dataset.selling = '';
            }
        }

        // check for auto sell (we need to re-update the selling plan)
        if (item.querySelector('.collectionItemATC').dataset.auto === 'true') {
            item.querySelector('.quickAdd').dataset.selling = getSellingPlanID();
        }


    }

    // update item on load
    updateItem();
})


/**************
 Collection Item V2
 ***************/
document.querySelectorAll('.collectionItemV2')?.forEach(function (item) {

    let product = JSON.parse(item.dataset.product);
    let activeItemVariant = JSON.parse(item.dataset.variant);
    const subscriptionAppID = item.dataset.subscriptionAppId;

    // skip items without a variant so one bad block doesn't break the rest
    if (!activeItemVariant) {
        return;
    }

    // function to return the selling_plan_id given a variant ID
    function getSellingPlanID() {
        // create an array of selling plans that are accessible for the variant
        const validSellingPlans = [];

        // loop over each group
        for (const group of product.selling_plan_groups) {
            // if the group doesn't match our subscription app ID, skip it
            if (group.app_id !== subscriptionAppID) {
                continue
            }

            // loop through each selling plan in the group
            for (const plan of group.selling_plans) {
                // add the plan ID to the validSellingPlans array
                validSellingPlans.push(plan.id);
            }
        }

        // loop through selling plan allocations of the variant and find the first one that matches a valid selling plan
        for (const allocation of activeItemVariant.selling_plan_allocations) {
            if (validSellingPlans.includes(allocation.selling_plan_id)) {
                return allocation.selling_plan_id;
            }
        }

        // if no valid selling plan is found, return null
        return null;
    }

    // Update Item
    function updateItem() {

        // get active variant
        activeItemVariant = JSON.parse(item.dataset.variant);

        /**************
         Price
         ***************/
        let compare = item.querySelector(".collectionItemV2PriceCompare");
        let real = item.querySelector(".collectionItemV2PriceActual");

        // reset compares
        compare.textContent = "";

        let quickAddExists = item.querySelector('.quickAdd') || false;


        // find the allocation that matches the selling plan ID
        let allocation = activeItemVariant.selling_plan_allocations.find(allocation => allocation.selling_plan_id === getSellingPlanID());

        if (allocation) {
            let allocationPrice = allocation.price;
            let compare_price = allocation.compare_at_price;
            if (activeItemVariant.compare_at_price > compare_price) {
                compare_price = activeItemVariant.compare_at_price;
            }

            // Update subscription prices
            if (allocationPrice < compare_price) {
                compare.textContent = price(compare_price, true);
            }
            real.textContent = price(allocationPrice, true);

            if (quickAddExists) {
                item.querySelector('.quickAdd').dataset.selling = getSellingPlanID();
            }
        } else {
            // Update one-time purchase prices
            if (activeItemVariant.compare_at_price > activeItemVariant.price) {
                compare.textContent = price(activeItemVariant.compare_at_price, true);
            }
            real.textContent = price(activeItemVariant.price, true);

            if (quickAddExists) {
                item.querySelector('.quickAdd').dataset.selling = '';
            }
        }


    }


    // update item on load
    updateItem();
})


/**************
 Quick add
 ***************/
document.querySelectorAll('.quickAdd')?.forEach((item) => {
    item.addEventListener('click', async (e) => {
        e.preventDefault();

        item.classList.add('loading');

        let sellingPlan = null;

        // check for selling plan
        if (item.dataset.selling && item.dataset.selling !== '') {
            sellingPlan = parseInt(item.dataset.selling);
        }

        // check if this button should skip the free gift
        const skipFreeGift = item.dataset.skipFreeGift === 'true';

        let formData = {
            id: parseInt(item.dataset.id),
            quantity: 1,
            selling_plan: sellingPlan,
        }

        // check for extra products that should be added alongside this one
        if (item.dataset.autoAdd && item.dataset.autoAdd !== '') {
            const items = [formData];
            item.dataset.autoAdd.split(',').forEach((variantID) => {
                items.push({
                    id: parseInt(variantID),
                    quantity: 1
                });
            });
            formData = { items: items };
        }

        // check for a line item property to tag every item in this add with
        if (item.dataset.propertyKey && item.dataset.propertyKey !== '') {
            const items = formData.items || [formData];
            items.forEach((lineItem) => {
                lineItem.properties = {
                    [item.dataset.propertyKey]: item.dataset.propertyValue
                };
            });
        }

        // add product to cart
        await addProduct(formData, skipFreeGift);

        // // open cart
        // await openCart();

        item.classList.remove('loading');
    });
})

